import news from './news'
import infrastructure from './infrastructure'
import gallery from './gallery'
import sitetree from './sitetree'
import sites from './sites'
import actions from './actions'
import banners from './banners'
import socialgallery from './socialgallery'
import scripts from './scripts'

export default {
  content: {
    namespaced: true,
    modules: {
      news,
      infrastructure,
      gallery,
      sitetree,
      actions,
      sites,
      banners,
      socialgallery,
      scripts,
    },
  },
}
